import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-auth-arrow",
  "use": "icon-auth-arrow-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-auth-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.8545 6.31458L10.523 0.3125L11.977 1.68573L5.60201 8.43591L4.89549 9.18401L4.16788 8.4564L0.0429077 4.3314L1.45713 2.91719L4.8545 6.31458Z\" fill=\"#5587F0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol